import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="monitoring--host"
export default class extends Controller {
  static targets = ['hostValue', 'hostName', 'hostLat', 'hostLng' ]

  connect() {
  }

  cleanFields(){
    this.hostNameTarget.value = ''
    this.hostLatTarget.value = ''
    this.hostLngTarget.value = ''
  }

  setHostName(){
    if (this.hostValueTarget.value){
      let values = this.hostValueTarget.tomselect.options;
      let name = values[this.hostValueTarget.value]['name']
      let lat = values[this.hostValueTarget.value]['lat']
      let lng = values[this.hostValueTarget.value]['lng']

      this.hostNameTarget.value = name
      this.hostLatTarget.value = lat
      this.hostLngTarget.value = lng
    }
  }


}
